import i18n from './i18n';

function localeFor(lang) {
  return (lang || 'pl').startsWith('en') ? 'en-GB' : 'pl-PL';
}

export function formatCurrency(val) {
  const locale = localeFor(i18n.language);
  const num = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val || 0);
  return `${num} ${i18n.t('common.currency')}`;
}

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString(localeFor(i18n.language));
}

export function formatDateTime(dateStr, opts = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleString(localeFor(i18n.language), opts);
}

const STATUSY_SPACER_DATA = [
  { value: 'aktywny',     i18nKey: 'spaces.active',           color: 'text-green-400',  bg: 'bg-green-900/30 border-green-800' },
  { value: 'zamrozony',   i18nKey: 'spaces.frozen',           color: 'text-sky-400',    bg: 'bg-sky-900/30 border-sky-800' },
  { value: 'przekazany',  i18nKey: 'spaces.transferredStatus', color: 'text-purple-400', bg: 'bg-purple-900/30 border-purple-800' },
  { value: 'usuniety',    i18nKey: 'spaces.deleted',          color: 'text-red-400',    bg: 'bg-red-900/30 border-red-800' },
];

export function getStatusySpacer() {
  return STATUSY_SPACER_DATA.map(s => ({ ...s, label: i18n.t(s.i18nKey) }));
}

export function statusSpacerMeta(status) {
  const data = STATUSY_SPACER_DATA.find(s => s.value === status) || STATUSY_SPACER_DATA[0];
  return { ...data, label: i18n.t(data.i18nKey) };
}

export function statusSpacerColor(status) {
  return statusSpacerMeta(status).color;
}

const STATUSY_ROZL_DATA = [
  { value: 'oplacone',    i18nKey: 'settlement.oplacone',    color: 'text-green-400' },
  { value: 'nieoplacone', i18nKey: 'settlement.nieoplacone', color: 'text-yellow-400' },
];

export function statusRozlColor(status) {
  return STATUSY_ROZL_DATA.find(s => s.value === status)?.color || 'text-navy-300';
}

export const DARMOWE_OPCJE = [0, 1, 3, 6, 12];

export function getMonthsShort() {
  return i18n.t('monthsShort', { returnObjects: true });
}
